import React from 'react'

type PropsT = {
  className?: string
  fillColor?: string
  backgroundColor?: string
}

const BarChart: React.FC<PropsT> = ({
  className,
  fillColor = '#13C1BF',
  backgroundColor = '#F1FBFB',
}) => (
  <svg
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="4" fill={backgroundColor} />
    <path
      d="M14 33V31H34V33H14ZM15 30V23H18V30H15ZM20 30V18H23V30H20ZM25 30V21H28V30H25ZM30 30V15H33V30H30Z"
      fill={fillColor}
    />
  </svg>
)

export default BarChart
